<div class="page-padding">
    <section class="token-verify-wrapper">
        <div *ngIf="invalidRequest" class="invalid-request">
            <h2>Unauthorized</h2>
            <p>You are not authorized to access this page.</p>
            <button class="mt-2" mat-flat-button color="secondary" (click)="gotToLogin()">Log in</button>
        </div>
        <div *ngIf="expiredToken" class="invalid-request">
            <h2>Secure Link has Expired</h2>
            <p>The secure link to upload documents has expired. If you still have documents to share with the dealer, contact them to request a new link.</p>
        </div>
        <div *ngIf="!invalidRequest && !expiredToken && !isLoading" class="redirect-message">
            <h2>Redirecting...</h2>
        </div>
    </section>
</div>
<ddj-spinner *ngIf="isLoading"></ddj-spinner>
